import React from 'react';
import { ArrowRight, UserPlus, ClipboardCheck, Wallet, ShieldCheck, DollarSign, CheckCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const Workflow = () => {
  const steps = [
    {
      icon: UserPlus,
      title: 'Nasabah Menyetor Sampah',
      description: 'Nasabah membawa sampah ke lapak atau menghubungi petugas untuk pengambilan.',
    },
    {
      icon: ClipboardCheck,
      title: 'Petugas Mencatat Transaksi',
      description: 'Petugas menimbang dan mencatat jenis serta berat sampah ke dalam sistem.',
    },
    {
      icon: Wallet,
      title: 'Saldo Tercatat di Sistem',
      description: 'Sistem otomatis menghitung nilai sampah dan menambahkan saldo ke akun nasabah.',
    },
    {
      icon: ShieldCheck,
      title: 'Admin Melakukan Verifikasi',
      description: 'Admin memverifikasi transaksi dan memproses pengajuan penarikan saldo.',
    },
    {
      icon: DollarSign,
      title: 'Penarikan Saldo Diproses',
      description: 'Dana ditransfer ke metode penarikan yang dipilih nasabah atau rekanan.',
    },
    {
      icon: CheckCircle,
      title: 'Pembayaran & Distribusi Dana',
      description: 'Admin mengelola pembayaran ke lapak dan distribusi dana operasional.',
    },
  ];

  return (
    <section id="workflow" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-6 bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-300 bg-clip-text text-transparent">
            Alur Proses Sistem
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400 max-w-3xl mx-auto">
            Proses end-to-end dari penyetoran sampah hingga distribusi dana yang terkelola dengan baik
          </p>
        </div>

        {/* Workflow Steps */}
        <div className="relative">
          {/* Connection Line - Desktop */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-emerald-200 via-teal-200 to-emerald-200 dark:from-emerald-900 dark:via-teal-900 dark:to-emerald-900" style={{ top: '120px' }}></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 relative">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <Card className="group border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 hover:shadow-2xl hover:border-emerald-500 dark:hover:border-emerald-500 transition-all duration-300 hover:-translate-y-2 h-full">
                  <CardContent className="p-8">
                    {/* Step Number */}
                    <div className="absolute -top-4 -left-4 bg-gradient-to-br from-emerald-600 to-teal-600 w-12 h-12 rounded-xl flex items-center justify-center shadow-lg z-10">
                      <span className="text-white font-bold text-lg">{index + 1}</span>
                    </div>

                    {/* Icon */}
                    <div className="bg-gradient-to-br from-emerald-500 to-teal-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform duration-300 shadow-lg">
                      <step.icon className="h-8 w-8 text-white" />
                    </div>

                    {/* Content */}
                    <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3 text-center">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 dark:text-slate-400 text-center leading-relaxed">
                      {step.description}
                    </p>

                    {/* Arrow - Only show between steps on desktop */}
                    {index < steps.length - 1 && (
                      <div className="hidden lg:block absolute top-1/2 -right-8 transform -translate-y-1/2 z-20">
                        <ArrowRight className="h-6 w-6 text-emerald-500" />
                      </div>
                    )}
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>

        {/* Summary Card */}
        <Card className="mt-16 border-emerald-200 dark:border-emerald-800 bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20">
          <CardContent className="p-8 text-center">
            <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">
              Sistem Terintegrasi & Transparan
            </h3>
            <p className="text-lg text-slate-600 dark:text-slate-400 max-w-3xl mx-auto">
              Setiap tahap dalam proses dicatat dan dapat dilacak, memastikan akuntabilitas dan kepercayaan semua pihak yang terlibat dalam ekosistem Bank Sampah Digital.
            </p>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default Workflow;